
  <div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Taekwondo Program</h2>
        <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
        <p>
          The Taekwondo Program at Innovative Vision is a dynamic 
          martial arts discipline that offers a structured path for physical and
           mental growth. Beyond teaching self-defense techniques, our program instills
            core values that are crucial for a child's holistic development.
           It's a journey of self-discovery that builds discipline, confidence, and respect.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg//programDetails/tikH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
<div class="key-focus-section m-3">
  <div class="image-container">
    <img src="assets/ivimg//programDetails/tikF.svg" alt="Key Focus Areas"/>
  </div>
  <div class="content">
    <h2 class="section-title">Key Focus Areas</h2>
    <div class="points">
      <p>
        <strong>1. Discipline & Focus:</strong>  Taekwondo is a practice that demands concentration and discipline. Children learn to follow instructions, control their movements, and focus their energy. This training translates into improved behavior and better concentration in all aspects of their lives.
      </p>
      <p> 
        <strong>2. Physical Fitness & Coordination:</strong> The program's physical movements—including kicks, blocks, and stances are excellent for developing gross motor skills, strength, flexibility, and endurance. Regular practice enhances a child's overall physical health and body awareness.
      </p>
      <p> 
        <strong>3. Self-Confidence & Respect:</strong> As children progress through the ranks (signified by belt colors), they gain a sense of accomplishment and pride, which boosts their self-confidence. They also learn the importance of respecting their instructors and peers, fostering a humble and respectful attitude.
      </p> 
    </div>
  </div>
</div>


<div class="program-highlights">
  <div class="highlight-container">
    <!-- Image from assets -->
    <div class="image-container">
      <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
    </div>

    <!-- Text Content -->
    <div class="text-container">
      <h2 class="title">Program Highlights</h2>
      <p> 
        <strong>Certified Instructors:</strong> Our classes are led by certified Taekwondo instructors who are experienced in teaching and mentoring children. They provide a safe and encouraging environment for every student.
      </p>
      <p> 
        <strong>Structured Ranking System:</strong> The program follows a recognized belt system, providing a clear path for progression. This gives children tangible goals to work towards, motivating them to practice and improve.
      </p>
      <p>
        <strong>Holistic Approach:</strong>Our curriculum goes beyond just physical techniques. It incorporates our core philosophy of nurturing the mind, body, and soul, ensuring a balanced and comprehensive learning experience.
      </p>
    </div>
  </div>
</div> 
<div class="benefits-section">
  <h2 class="benefits-title">Benefits for Your Child</h2>
  <p class="benefits-text">
    Our Taekwondo program offers numerous benefits that contribute to a child's overall well-being.
     It helps them build a strong foundation of discipline and focus, which is essential for academic
      success and personal growth. The physical nature of the sport improves their health and coordination,
       while the structured progression builds confidence and self-esteem. Furthermore, Taekwondo teaches
        valuable life lessons in respect, humility, and perseverance, helping to shape well-rounded and 
        resilient individuals.
  </p>
</div>
